module.exports = __webpack_public_path__ + "f3fe9068.png";